import React, { useEffect, useState} from 'react';
import { ClipLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

import './Home.css';
import Header from '../header/Header.js';
import Footer from '../footer/Footer.js';
import * as CertificatePortalAccessConstants from '../../data/CertificatePortalAccessConstants.js';
import { getPortalAccessStatus, setPortalAccessStatus } from '../../utils/CertificatePortalAccessController.js';

const Home = ({user, accessStatus, acessStatusHandler}) => {
    const [loadingAccessStatus, setLoadingAccessStatus] = useState(false);
    const [updateAccessStatus, setUpdateAccessStatus] = useState();
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {setUpdateAccessStatus(); setOpen(false);}
    const navigate = useNavigate();

    const capitalizeFirstLetter = (str) => {
        return str
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const isAccessLocked = () => {
        return accessStatus.value === CertificatePortalAccessConstants.PARAMETER_LOCK_VALUE;
    }

    const isDisabled = () => {
        return false;
    }

    const updateAccessStatusValue = async () => {
        setLoadingAccessStatus(true);
        let newStatus = (isAccessLocked())
            ? CertificatePortalAccessConstants.PARAMETER_UNLOCK_VALUE
            : CertificatePortalAccessConstants.PARAMETER_LOCK_VALUE

        const updateAccessResponse = await setPortalAccessStatus(newStatus);
        setUpdateAccessStatus(updateAccessResponse);
        if(updateAccessResponse.success) {
            const accessStatus = await getPortalAccessStatus();
            acessStatusHandler(accessStatus);

        }

        setLoadingAccessStatus(false);
    }

    return (
        <div>
            <Header/>
            <div className="container home">
                {isAccessLocked() ? (
                    <div className="warning-banner">
                        { (user.isAdminRol)
                            ? <Alert severity="warning">{CertificatePortalAccessConstants.PORTAL_LOCK_LABEL}</Alert>
                            : <Alert severity="warning">
                                El visor de informes no está disponible temporalmente por vigencia de encuestas, si necesitas un certificado contacta con Calidad Madrid:&nbsp;
                                <a href="mailto:calidad@universidadeuropea.es">calidad@universidadeuropea.es</a> o Unidad Calidad Valencia:&nbsp;
                                <a href="mailto:unidadcalidadvalencia@universidadeuropea.es">unidadcalidadvalencia@universidadeuropea.es</a> o Calidad UEC:&nbsp;
                                <a href="mailto:calidad.uec@universidadeuropea.es">calidad.uec@universidadeuropea.es</a>. Muchas gracias.</Alert>
                        }
                    </div>
                ) : null}
                <h1 className="title">Bienvenid@ {user ? capitalizeFirstLetter(user.givenName.toLowerCase()) : ''}</h1>
                <div className="container-btn">
                    <button className={isDisabled() ? "btn-primary-home-disabled" : "btn-primary-home"} disabled={isDisabled()} onClick={() => { navigate(`/certificateReports`) }}>Certificado del profesor</button><br />
                    <button className={isDisabled() ? "btn-primary-home-disabled" : "btn-primary-home"} disabled={isDisabled()} onClick={() => { navigate(`/facultyReports`) }}>Informe del profesor</button><br />
                    {(user.isAdminRol)
                        ? <div><button className="btn-primary-home" onClick={handleOpen}>Gestionar acceso al portal</button><br /></div>
                        : null
                    }
                    <button className="btn-primary-home" onClick={() => { Auth.signOut() }}>Cerrar sesión</button>
                </div>
            </div>
            <Modal open={open} onClose={handleClose}>
                <Box className="access-controller-modal">
                    { (updateAccessStatus) ? <Alert severity={(updateAccessStatus.success) ? "success" :"error"}>{updateAccessStatus.label}</Alert> : null}
                    <div className='text-align-center'>
                        <h1 className="title">Control de acceso al portal</h1>
                    </div>
                    <div className='modal-description'>
                        <p className='text-align-justify'>El control de acceeso al portal permite restringir la entrada al visor de informes durante la vigencia de las encuestas de satisfacción. Activando esta opción solo los usuarios administradores del portal tendrán acceso al visor de informes.</p>
                        <p className='text-weight-bold'>Estado actual: <span className={isAccessLocked() ? "text-color-red" : "text-color-green"}>{accessStatus.label}</span></p>
                        <div className="btn-modal-container">
                            { (loadingAccessStatus) ? (
                                <div className="spinner-inner-container">
                                    <ClipLoader color="red" loading={loadingAccessStatus} size={50} />
                                </div>
                            ) : (
                                (updateAccessStatus)
                                    ? <button className="btn-modal" onClick={() => {handleClose()}}>Cerrar</button>
                                    : <div className='btn-modal-group'>
                                        <button className="btn-modal" onClick={() => {updateAccessStatusValue()}}>{(isAccessLocked()) ? "Abrir acceso" : "Restringir acceso"}</button>
                                        <button className="btn-modal" onClick={() => {handleClose()}}>Cancelar</button>
                                    </div>
                            )}
                        </div>
                    </div>
                </Box>
            </Modal>
            <Footer className="footer"/>
        </div>
    );
};

export default Home;